import styles from './DiscountAndOffer.module.scss';

//importing components
import { Col, Row } from 'antd';
import Layout from '../../Components/Layout/Layout';
import Loader from '../../Components/Loader/Loader';
import ProductCard from '../../Components/ProductCard/ProductCard';
import { useDiscountedProducts } from '../../Hooks/useProductsBySubCategory';

const DiscountAndOffer = () => {
  // same cache entry as the landing page's "Discounts & Offers" slider
  const { products, loading } = useDiscountedProducts();

  return (
    <Layout>
      <section
        className='container'
        style={{ padding: window.innerWidth > 576 ? '4rem 0rem' : '4rem 1.5rem' }}
      >
        {loading ? (
          <Loader height={'50vh'} />
        ) : (
          <Row>
            <Col span={24}>
              <h1 className={styles.title}>Discounts & Offers</h1>
            </Col>
            {products?.map((product, index) => (
              <Col lg={6} xs={12} className={styles.cat_products_grid} key={index}>
                <ProductCard discountOnly product={product} />
              </Col>
            ))}
          </Row>
        )}
      </section>
    </Layout>
  );
};

export default DiscountAndOffer;
